/** Turns a picked photo into a small square avatar (centre crop, 256 px) for upload. */

export const AVATAR_PX = 256;
export const AVATAR_MAX_BYTES = 200 * 1024;

function toBlob(canvas: HTMLCanvasElement, type: string, quality: number): Promise<Blob | null> {
  return new Promise((resolve) => canvas.toBlob(resolve, type, quality));
}

/**
 * Square-crops and scales the image, then encodes WebP (JPEG where the browser cannot encode
 * WebP, e.g. Safari — browsers sniff image bytes, so it still displays), lowering quality
 * until it fits AVATAR_MAX_BYTES.
 */
export async function makeAvatar(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const side = Math.min(bitmap.width, bitmap.height);
  const canvas = document.createElement('canvas');
  canvas.width = AVATAR_PX;
  canvas.height = AVATAR_PX;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Не удалось обработать фото');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(
    bitmap,
    (bitmap.width - side) / 2,
    (bitmap.height - side) / 2,
    side,
    side,
    0,
    0,
    AVATAR_PX,
    AVATAR_PX,
  );
  bitmap.close();

  for (const quality of [0.86, 0.75, 0.6, 0.45]) {
    let blob = await toBlob(canvas, 'image/webp', quality);
    if (!blob || blob.type !== 'image/webp') blob = await toBlob(canvas, 'image/jpeg', quality);
    if (blob && blob.size <= AVATAR_MAX_BYTES) return blob;
  }
  throw new Error('Фото слишком большое');
}
